var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWord = function SvgWord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 400 400",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Schermata_2019-08-29_alle_16.51.10-2",
    "data-name": "Schermata 2019-08-29 alle 16.51.10-2",
    width: 400,
    height: 400,
    rx: 25,
    fill: "#295bb7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Schermata_2019-08-29_alle_16.51.10-3",
    "data-name": "Schermata 2019-08-29 alle 16.51.10-3",
    d: "M25,0H375a25,25,0,0,1,25,25V375C400,388.81,11.19,0,25,0Z",
    fill: "#417ccd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1821",
    "data-name": "Rectangle 1821",
    y: 69,
    width: 400,
    height: 150,
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/word.ae0c45fc.svg";
export { ForwardRef as ReactComponent };